import { createSlice } from "@reduxjs/toolkit";
import {     profile_add_imageThunk } from "./thunk";


export const initialState = {
  profileAddImageData: [],
  profileAddImageError: {
    code: null,
    message: '',
    data: null
  },
  profileAddImageLoading: false,
  
  
};

const Add_Profile_Image = createSlice({
  name: "Add_Profile_Image",
  initialState, 
  reducers: {}, 
  extraReducers: (builder) => {

    builder.addCase(profile_add_imageThunk.pending, (state) => {
      state.profileAddImageLoading = true ;
      state.profileAddImageError = initialState.profileAddImageError; 
      state.profileAddImageData = []; 
  });
    builder.addCase(profile_add_imageThunk.fulfilled, (state, action) => {
        state.profileAddImageData = action.payload.data;
        state.profileAddImageLoading = false ;
    });
    builder.addCase(profile_add_imageThunk.rejected, (state, action) => {
      state.profileAddImageError = {
        code: action.payload?.code || null,
        message: action.payload?.message || "An unknown error occurred",
        data: action.payload?.data || null
      };
        state.profileAddImageLoading = false ;
    });
}
});

export const {
  apiRequest,
  apiError,
  
  
} = Add_Profile_Image.actions

export default Add_Profile_Image.reducer;